export default __webpack_public_path__ + "static/media/BDSBanner1.a1a5cb3e.png";